// セレクトボックスから選択
// =====================================================

// バインディング
// ==============
$(function () {
    $("#selectBinding").change(function () {
        // 選択オプションのvalueを取得
        let valBinding = $(this).val();
        // idに変換
        let selectBindingId = "#" + valBinding;
        // 一度リストを非表示
        $("#sim_bindingArea .select-img_box").hide();
        // 選択したバインのみ表示
        $(selectBindingId).show();
    });
});

// ボード
// ==============

$(function () {
    $("#selectBoard").change(function () {
        // 選択オプションのvalueを取得
        let valBoard = $(this).val();
        // idに変換
        let selectBoardId = "#" + valBoard;
        // 一度リストを非表示
        $("#sim_boardArea .select-img_box").hide();
        // 選択したバインのみ表示
        $(selectBoardId).show();
    });
});

// 選択画像をシミュレーションエリアに表示
// =====================================================

// バインディング
// ==============

$(".select-img_binding").on("click", function () {
    $(".select-img_binding").removeClass("selected");
    $(this).addClass("selected");
    changeBinding();
});

// タグを生成
function changeBinding() {
    let s_html = "";
    $(".select-img_binding.selected").each(function (index, element) {
        s_html +=
            '<img class="selected_binding" src="' +
            $(element).find("img").eq(1).attr("src") +
            '">';
    });

    // 要素削除
    $("#sim_display img").each(function (index, element) {
        if ($(this).hasClass("selected_binding")) {
            $(this).remove();
        }
    });

    // 要素追加
    $("#sim_display").append(s_html);
}

// ボード
// ==============

$(".select-img_board").on("click", function () {
    $(".select-img_board").removeClass("selected");
    $(this).addClass("selected");
    changeBoard();
});

// タグを生成
function changeBoard() {
    let s_html = "";
    $(".select-img_board.selected").each(function (index, element) {
        s_html +=
            '<img class="selected_board" src="' +
            $(element).find("img").eq(1).attr("src") +
            '">';
    });

    // 要素削除
    $("#sim_display img").each(function (index, element) {
        if ($(this).hasClass("selected_board")) {
            $(this).remove();
        }
        $(".base-img").remove();
    });
    // 要素追加
    $("#sim_display").append(s_html);
}

